import { useContext } from 'react';

import { SearchContext } from '@/contexts/Search.context';

export function useSearchData() {
  return useContext(SearchContext);
}
